module.exports = __webpack_public_path__ + "img/trator-producao.59eac736.svg";